import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-387f5c74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OSelecionarTiposDeAtividade__ColumnConteudo" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Limpar ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Aplicar ")
const _hoisted_4 = { class: "OSelecionarTiposDeAtividade__ColumnConteudo" }
const _hoisted_5 = { class: "OSelecionarTiposDeAtividade__BotoesNovosTiposDeAtividade" }

import { computed, ref, onMounted } from "vue"

  // componentes
  import Column from "primevue/column"

  import DataTable, { DataTableFilterMeta } from "primevue/datatable"
  import PButton from "primevue/button"
  import { PageState } from "primevue/paginator"
  import { MInput, APaginadorDeTabela } from "@/components/Gerais"

  // composables
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarFiltragem } from "@/composable/UsarFiltragem"

  // tiposDeAtividade
  import {
    ListarTiposDeAtividade,
    ListarTiposDeAtividadeFormatado,
    ParamsTiposDeAtividade,
  } from "@/repositorios/tiposDeAtividade/tiposDeAtividade.modelo"
  import TiposDeAtividadeRepositorio from "@/repositorios/tiposDeAtividade/tiposDeAtividade.repositorio"
  import tabelaTiposDeAtividade from "./OSelecionarTiposDeAtividade.script"

  import Skeleton from "primevue/skeleton"
  import { useI18n } from "vue-i18n"

  interface Props {
    tiposDeAtividadePreSelecionados: string[]
    tiposDeAtividadeSelecionados: ListarTiposDeAtividade[]
    destino?: string
  }

  type EmitirModel = {
    (
      event: "update:tiposDeAtividadeSelecionados",
      tiposDeAtividadeSelecionados: ListarTiposDeAtividade[]
    ): void
    (event: "onFecharTabelaDeAdicaoDeTiposDeAtividade"): void
    (event: "enviarTiposDeAtividadeSelecionados"): void
    (
      event: "adicionarTipoDeAtividade",
      tipoDeAtividade: ListarTiposDeAtividadeFormatado
    ): void
    (
      event: "removerTipoDeAtividade",
      tipoDeAtividade: ListarTiposDeAtividadeFormatado
    ): string
    (
      event: "update:tiposDeAtividadePreSelecionados",
      tiposDeAtividade: string[]
    )
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OSelecionarTiposDeAtividade',
  props: {
    tiposDeAtividadePreSelecionados: null,
    tiposDeAtividadeSelecionados: null,
    destino: null
  },
  emits: ["update:tiposDeAtividadeSelecionados", "onFecharTabelaDeAdicaoDeTiposDeAtividade", "enviarTiposDeAtividadeSelecionados", "adicionarTipoDeAtividade", "removerTipoDeAtividade", "update:tiposDeAtividadePreSelecionados"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (
      event: "update:tiposDeAtividadeSelecionados",
      tiposDeAtividadeSelecionados: ListarTiposDeAtividade[]
    ): void
    (event: "onFecharTabelaDeAdicaoDeTiposDeAtividade"): void
    (event: "enviarTiposDeAtividadeSelecionados"): void
    (
      event: "adicionarTipoDeAtividade",
      tipoDeAtividade: ListarTiposDeAtividadeFormatado
    ): void
    (
      event: "removerTipoDeAtividade",
      tipoDeAtividade: ListarTiposDeAtividadeFormatado
    ): string
    (
      event: "update:tiposDeAtividadePreSelecionados",
      tiposDeAtividade: string[]
    )
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    tiposDeAtividadePreSelecionados: string[]
    tiposDeAtividadeSelecionados: ListarTiposDeAtividade[]
    destino?: string
  }

  // framework cores
  
  

  const { t } = useI18n()

  const PRIMEIRA_PAGINA_PADRAO = 0
  const ALTURA_RELATIVA_DA_TABELA = "calc(100vh - 460px)"

  const tiposDeAtividadeRep = new TiposDeAtividadeRepositorio()

  const tiposDeAtividade = ref<ListarTiposDeAtividade[]>([])

  const {
    filtros: filtrosComposable,
    preencherFiltro,
    removerFiltro,
  } = usarFiltragem()

  const { filtrosTabelaSelecionarTiposDeAtividade } = tabelaTiposDeAtividade()

  const { leitor } = usarLeitorDeDados()

  const lerTiposDeAtividade = leitor<
    ListarTiposDeAtividade,
    ParamsTiposDeAtividade
  >(tiposDeAtividadeRep.listarTiposDeAtividade, {
    ativo: "igual.true",
    "ordenar-por": "asc.nome",
  })

  const carregandoTiposDeAtividade = computed(() => {
    return lerTiposDeAtividade.resultado.status === "pendente"
  })

  const quantidadeDeTiposDeAtividadeSelecionados = computed(
    () => {

      if (carregandoTiposDeAtividade.value) {
        return ""
      }

      return String(props.tiposDeAtividadeSelecionados.length +
      props.tiposDeAtividadePreSelecionados.length)
    }
  )

  const emitirSelecionados = computed({
    get() {
      return props.tiposDeAtividadeSelecionados
    },
    set(tiposDeAtividadeSelecionados: ListarTiposDeAtividade[]) {
      emitir(
        "update:tiposDeAtividadeSelecionados",
        tiposDeAtividadeSelecionados
      )
    },
  })

  const tiposDeAtividadePreSelecionados = computed({
    get() {
      return props.tiposDeAtividadePreSelecionados
    },
    set(tiposDeAtividadePreSelecionadas: string[]) {
      emitir(
        "update:tiposDeAtividadePreSelecionados",
        tiposDeAtividadePreSelecionadas
      )
    },
  })

  const onSelecionarLinha = (event) => {
    const { id, nome, codigo, duracaoPadraoEmMinutos } = event.data

    const tipoDeAtividadeFormatado: ListarTiposDeAtividadeFormatado = {
      id,
      nome,
      codigo,
      codigoOriginal: codigo,
      duracaoPadraoEmMinutos,
    }
    emitir("adicionarTipoDeAtividade", tipoDeAtividadeFormatado)
  }

  const onDesselecionarLinha = (event) => {
    const { id, nome, codigo, duracaoPadraoEmMinutos } = event.data

    const tipoDeAtividadeFormatado: ListarTiposDeAtividadeFormatado = {
      id,
      nome,
      codigo,
      codigoOriginal: codigo,
      duracaoPadraoEmMinutos,
    }
    emitir("removerTipoDeAtividade", tipoDeAtividadeFormatado)
  }

  const listarTiposDeAtividade = async (pagina: number, porPagina = 10) => {
    await lerTiposDeAtividade.porPagina(porPagina).pagina(pagina).executar()

    if (lerTiposDeAtividade.resultado.status === "sucesso") {
      tiposDeAtividade.value = lerTiposDeAtividade.resultado.dados
      definirItensPreSelecionados()
    }
  }

  const definirItensPreSelecionados = (): void => {
    const naoTemProjetosPreSelecionados =
      tiposDeAtividadePreSelecionados.value.length === 0
    if (naoTemProjetosPreSelecionados) {
      return
    }
    const pegarPreSelecionadosDaPaginaAtual = (): ListarTiposDeAtividade[] => {
      return tiposDeAtividade.value.filter(
        (tipoDeAtividade: ListarTiposDeAtividade) => {
          return (
            tipoDeAtividade.ativo &&
            props.tiposDeAtividadePreSelecionados.includes(tipoDeAtividade.id)
          )
        }
      )
    }
    const removerRecemSelecionadosDaListaDePreSelecionados = (): string[] => {
      return tiposDeAtividadePreSelecionados.value.filter(
        (tipoDeAtividadePreSelecionado) => {
          return !tiposDeAtividadePreSelecionadosEncontrados.some(
              (tipoDeAtividade: ListarTiposDeAtividade) => {
                return tipoDeAtividade.id === tipoDeAtividadePreSelecionado
              }
            )
        }
      )
    }

    const somenteOsSelecionadosQueNaoEstaoPreSelecionados =
      (): ListarTiposDeAtividade[] => {
        return emitirSelecionados.value.filter((tipoDeAtividade) => {
          return !tiposDeAtividadePreSelecionados.value.some(
            (tipoDeAtividadePreSelecionado) => {
              return tipoDeAtividade.id === tipoDeAtividadePreSelecionado
            }
          )
        })
      }

    const tiposDeAtividadePreSelecionadosEncontrados =
      pegarPreSelecionadosDaPaginaAtual()

    tiposDeAtividadePreSelecionados.value =
      removerRecemSelecionadosDaListaDePreSelecionados()

    emitirSelecionados.value = [
      ...somenteOsSelecionadosQueNaoEstaoPreSelecionados(),
      ...tiposDeAtividadePreSelecionadosEncontrados,
    ]
  }

  const filtrarTiposDeAtividade = async () => {
    lerTiposDeAtividade.sobrescreverParametros({
      ...filtrosComposable.value,
    })

    lerTiposDeAtividade.primeiraPagina = PRIMEIRA_PAGINA_PADRAO
    await listarTiposDeAtividade(
      lerTiposDeAtividade.primeiraPagina,
      lerTiposDeAtividade.itensPorPagina
    )
  }

  const onPaginarTiposDeAtividade = async ({
    page,
    first,
    rows,
    pageCount,
  }: PageState) => {
    await listarTiposDeAtividade(page, rows)
  }

  const aplicarFiltros = async (
    dadosDoPreenchimentoDoFiltro: Record<string, any>,
    nomeDaColunaNaAPI: string
  ) => {
    const { matchMode, value } = (
      dadosDoPreenchimentoDoFiltro as DataTableFilterMeta
    ).constraints[0]

    preencherFiltro(nomeDaColunaNaAPI, matchMode, value)

    filtrarTiposDeAtividade()
  }

  const limparFiltros = async (nome) => {
    removerFiltro(nome)
    filtrarTiposDeAtividade()
  }

  const enviarTiposDeAtividadeSelecionados = () => {
    emitir("enviarTiposDeAtividadeSelecionados")
  }
  const cancelarAdicaoDeTiposDeAtividade = () => {
    tiposDeAtividade.value = []
    emitirSelecionados.value = []
    emitir("onFecharTabelaDeAdicaoDeTiposDeAtividade")
  }

  onMounted(() => {
    listarTiposDeAtividade(lerTiposDeAtividade.primeiraPagina)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataTable), {
    filters: _unref(filtrosTabelaSelecionarTiposDeAtividade),
    "onUpdate:filters": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(filtrosTabelaSelecionarTiposDeAtividade) ? (filtrosTabelaSelecionarTiposDeAtividade).value = $event : null)),
      filtrarTiposDeAtividade
    ],
    selection: _unref(emitirSelecionados),
    "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (_isRef(emitirSelecionados) ? (emitirSelecionados).value = $event : null)),
    onRowSelect: onSelecionarLinha,
    onRowUnselect: onDesselecionarLinha,
    class: "OSelecionarTiposDeAtividade p-datatable-sm",
    "data-key": "id",
    "data-testid": "OSelecionarTiposDeAtividade",
    "filter-display": "menu",
    loading: _unref(carregandoTiposDeAtividade),
    "meta-key-selection": false,
    "responsive-layout": "scroll",
    rows: _unref(lerTiposDeAtividade).itensPorPagina,
    "scroll-height": ALTURA_RELATIVA_DA_TABELA,
    scrollable: "",
    "selection-mode": "multiple",
    "striped-rows": "",
    value: tiposDeAtividade.value
  }, {
    loading: _withCtx(() => [
      _createVNode(_unref(Skeleton), {
        height: "100%",
        width: "100%"
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(APaginadorDeTabela), {
        "ao-paginar": onPaginarTiposDeAtividade,
        leitor: _unref(lerTiposDeAtividade)
      }, null, 8, ["leitor"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(PButton), {
          onClick: enviarTiposDeAtividadeSelecionados,
          class: "OSelecionarTiposDeAtividade__Adicionar p-button-success",
          "data-testid": "OSelecionarTiposDeAtividade__Adicionar",
          label: `${_unref(t)('adicionar')} ${_unref(quantidadeDeTiposDeAtividadeSelecionados)} ${_unref(t)('atividades')}`
        }, null, 8, ["label"]),
        _createVNode(_unref(PButton), {
          onClick: cancelarAdicaoDeTiposDeAtividade,
          class: "OSelecionarTiposDeAtividade__Cancelar p-button-danger",
          "data-testid": "OSelecionarTiposDeAtividade__Cancelar",
          label: _unref(t)('cancelar')
        }, null, 8, ["label"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        class: "OSelecionarTiposDeAtividade__Column",
        field: "nome",
        header: _unref(t)('nome'),
        "show-add-button": false,
        "show-filter-operator": false,
        sortable: ""
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(data.nome), 1)
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_unref(MInput), {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            nome: "filtro-nome",
            placeholder: _unref(t)('pesquisarPorNome'),
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
        ]),
        filterclear: _withCtx(({ field }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (limparFiltros(field))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        filterapply: _withCtx(({ filterModel, field }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (aplicarFiltros(filterModel, field))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_unref(Column), {
        class: "OSelecionarTiposDeAtividade__Column",
        field: "codigo",
        header: _unref(t)('codigo'),
        "show-add-button": false,
        "show-filter-operator": false
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_4, _toDisplayString(data.codigo), 1)
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_unref(MInput), {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            nome: "codigo",
            placeholder: _unref(t)('pesquisarPorCodigo'),
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
        ]),
        filterclear: _withCtx(({ field }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (limparFiltros(field))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        filterapply: _withCtx(({ filterModel, field }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (aplicarFiltros(filterModel, field))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 1
  }, 8, ["filters", "selection", "loading", "rows", "value"]))
}
}

})